export default __webpack_public_path__ + "media/images/hero-house-b5902406e2c2593e17ba15f395bdc0a8.png";